// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { TransferInstruction } from '@daml.js/splice-api-token-transfer-instruction/lib/Splice/Api/Token/TransferInstructionV1';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import InterfaceContract from '../../../../utils/InterfaceContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

// useTransferInstructions.ts

export const useTransferInstructions = <T = InterfaceContract<TransferInstruction>[]>(
  // We add an optional select parameter
  select?: (data: InterfaceContract<TransferInstruction>[]) => T,
): UseQueryResult<T, string> => {
  const ledgerApi = useLedgerApiClient();

  return useQueryWithOptions({
    queryKey: ['queryTransferInstructions'],
    queryFn: async (_, options) => {
      return ledgerApi.queryTransferInstructions(options);
    },
    select,
  });
};
